import { LaptopIcon } from './LaptopIcon';

/**
 * author: Google
 * id A8B6481F-EE91-4F90-81AC-DEB8A096F45A
 * name laptop
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/laptop.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const ComputerIcon = LaptopIcon;
export default ComputerIcon